import type { CandidateStatus, SearchStatus, Language } from '@sourcr/shared';
import { I18N } from '../../lib/i18n';

// Colors only — labels come from i18n so badges follow the active language.
const SEARCH_STATUS_STYLES: Record<SearchStatus, { bg: string; color: string }> = {
  pending: { bg: 'var(--bg-overlay)', color: 'var(--text-muted)' },
  ready: { bg: 'oklch(26% 0.08 65)', color: 'oklch(80% 0.16 65)' },
  running: { bg: 'oklch(30% 0.1 250)', color: 'oklch(75% 0.18 250)' },
  completed: { bg: 'oklch(22% 0.08 142)', color: 'oklch(72% 0.18 142)' },
  failed: { bg: 'oklch(20% 0.08 22)', color: 'oklch(65% 0.22 22)' },
};

const CANDIDATE_STATUS_STYLES: Record<CandidateStatus, { bg: string; color: string }> = {
  pending: { bg: 'var(--bg-overlay)', color: 'var(--text-muted)' },
  reviewed: { bg: 'oklch(26% 0.08 65)', color: 'oklch(78% 0.17 65)' },
  contacted: { bg: 'oklch(22% 0.08 142)', color: 'oklch(72% 0.18 142)' },
  declined: { bg: 'oklch(20% 0.08 22)', color: 'oklch(65% 0.22 22)' },
};

export function SearchStatusBadge({ status, lang = 'en' }: { status: SearchStatus; lang?: Language }) {
  const s = SEARCH_STATUS_STYLES[status];
  const label = I18N[lang].dashboard.status[status];
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        padding: '2px 8px',
        borderRadius: 9999,
        backgroundColor: s.bg,
        color: s.color,
        fontSize: 12,
        fontWeight: 500,
      }}
    >
      {status === 'running' && (
        <span
          style={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            backgroundColor: s.color,
            animation: 'pulse 1.5s ease-in-out infinite',
          }}
        />
      )}
      {label}
    </span>
  );
}

export function CandidateStatusBadge({
  status,
  lang = 'en',
  onClick,
}: {
  status: CandidateStatus;
  lang?: Language;
  onClick?: () => void;
}) {
  const s = CANDIDATE_STATUS_STYLES[status];
  const label = I18N[lang].favorites.status[status];
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '3px 10px',
        borderRadius: 9999,
        backgroundColor: s.bg,
        color: s.color,
        fontSize: 12,
        fontWeight: 500,
        border: 'none',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'opacity 0.15s',
      }}
    >
      {label}
    </button>
  );
}
